import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { UTCToCustomFormat } from '../../../ui/utils';

export const getAuditHistoryLog: GetColumnsType = () => [
  {
    key: 'createdDate',
    text: 'Date',
    width: 3,
    render: (object: DynamicObjectInterface) => (
      <span>{UTCToCustomFormat(object.createdDate, 'DD/MM/yyyy HH:mm')}</span>
    ),
  },
  {
    key: 'createdBy',
    text: 'Updated By',
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.createdBy}</span>,
  },
  {
    key: 'action',
    text: 'Action',
    width: 4,
    render: (object: DynamicObjectInterface) => <span>{object.action}</span>,
  },
];
